import { getStorage } from '@/libs/utils';
/**
 *
 * @param {*} info 正常支付pay_type
 * @param {*} qrcode_status 当前包是否开启二维码支付
 * @param {*} qrcode_info 二维码支付payType
 */
export const mergeQrCode = (info, qrcode_status, qrcode_info) => {
  const isEmulator = getStorage('isEmulator');
  const isInstallWeChat = getStorage('isInstallWeChat');
  const isInstallAlipay = getStorage('isInstallAlipay');
  if (qrcode_status !== 1) {
    // 未开启二维码支付
    return info;
  } else if (isEmulator == true || (isInstallWeChat == false && isInstallAlipay == false)) {
    // 开启二维码支付并且是模拟器只返回二维码支付
    // 开启二维码非模拟器 未安装支付宝、未安装微信 只返回二维码支付
    return qrcode_info.map((item) => {
      return {
        ...item,
        isQrCode: true,
      };
    });
  } else if (isInstallWeChat == true && isInstallAlipay == false) {
    // 开启二维码非模拟器 安装微信、未安装支付宝 返回微信正常支付支付宝二维码支付
    const wxPayInfo = info.filter((item) => item.img_class_name === 'wechat');
    let aliPayInfo = qrcode_info.filter((item) => item.img_class_name === 'alipay');
    aliPayInfo = aliPayInfo.map((item) => {
      return {
        ...item,
        isQrCode: true,
      };
    });
    return aliPayInfo.concat(wxPayInfo);
  } else if (isInstallWeChat == false && isInstallAlipay == true) {
    // 开启二维码非模拟器 安装支付宝、未安装微信 返回支付宝正常支付微信二维码支付
    const aliPayInfo = info.filter((item) => item.img_class_name === 'alipay');
    let wxPayInfo = qrcode_info.filter((item) => item.img_class_name === 'wechat');
    wxPayInfo = wxPayInfo.map((item) => {
      return {
        ...item,
        isQrCode: true,
      };
    });
    return aliPayInfo.concat(wxPayInfo);
  } else {
    return info;
  }
};
